import React from "react";
import { AppBar, Toolbar, Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const GuestNavbar = () => {
  const navigate = useNavigate();

  return (
    <AppBar position="sticky" color="default" elevation={1} sx={{ backgroundColor: "#ffffff" }}>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box display="flex" alignItems="center" sx={{ cursor: "pointer" }} onClick={() => navigate("/") }>
          <Box component="img" src="/Probate.jpeg" alt="Vermost" sx={{ height: 36, mr: 1 }} />
          <Typography variant="h6" sx={{ fontWeight: 400, color: "#333" }}>Probate Bond Pros Portal</Typography>
        </Box>
        <Box display="flex" gap={1}>
          <Button variant="text" onClick={() => navigate("/")} sx={{ textTransform: "none", color: "#333" }}>
            Back to Sign In
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default GuestNavbar;


